<template>
  <v-bottom-sheet style="z-index: 9999" v-model="sheet">
    <v-card class="text-center" tile :class="{ 'last-slide-active': step === slides.length - 1 }">
      <div class="promo-background" :class="{ 'ken-burns-active': sheet }">
        <div class="promo-overlay" :style="{ 'background-image': currentGradient }">
          <v-btn
            style="z-index: 99999"
            icon
            dark
            top
            right
            absolute
            @click="closeSheet"
            aria-label="Promotion schliessen"
            class="close-btn-animation">
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-container class="d-flex flex-column justify-center fill-height pa-4">
            <v-window v-model="step" transition="fade-transition">
              <v-window-item v-for="(slide, index) in slides" :key="`slide-${index}`" :value="index">
                <div class="white--text">
                  <h2 class="text-h5 text-md-h4 font-weight-bold mb-3 slide-in-up">
                    {{ slide.title }}
                  </h2>
                  <div
                    v-if="Array.isArray(slide.text)"
                    class="last-slide-text body-1 text-md-h6 font-weight-light slide-in-up"
                    style="animation-delay: 0.2s">
                    <div v-for="(line, i) in slide.text" :key="i" class="mb-1">{{ line }}</div>

                    <v-btn
                      v-if="index === slides.length - 1"
                      color="#E2B33B"
                      class="font-weight-bold mt-8 cta-button-animation"
                      dark
                      depressed
                      x-large
                      rounded
                      @click="bookNow">
                      Jetzt Platz sichern!
                    </v-btn>
                  </div>
                  <p v-else class="body-1 text-md-h6 font-weight-light slide-in-up" style="animation-delay: 0.2s" v-html="slide.text"></p>
                </div>
              </v-window-item>
            </v-window>

            <div class="mt-6 slide-in-up" style="animation-delay: 0.4s" v-if="step < slides.length - 1">
              <v-btn color="white" outlined rounded @click="nextStep"> Weiter </v-btn>
            </div>
          </v-container>
        </div>
      </div>
      <v-progress-linear v-model="progress" :active="step < slides.length - 1" color="#E2B33B" height="6" absolute bottom></v-progress-linear>
    </v-card>
  </v-bottom-sheet>
</template>

<script>
export default {
  name: "SportwochePromo",
  data: () => ({
    sheet: false,
    step: 0,
    progress: 0,
    progressInterval: null,
    slideDuration: 10000,
    slides: [
      {
        title: "Träumst du schon vom nächsten Sommer",
        text: "Plane jetzt dein Highlight 2026. <br>Sonne Training und Community warten auf dich in Antalya.",
        //gradient: "linear-gradient(45deg, rgba(102, 205, 170, 0.7), rgba(135, 206, 235, 0.75))",
        gradient: "linear-gradient(45deg, rgba(20, 180, 120, 0.65), rgba(30, 144, 255, 0.75))",
      },
      {
        title: "Jetzt Energie für den Sommer sammeln",
        text: "Der Winter kommt aber dein Ziel steht fest. <br>Die Sportwoche 2026 in der Sonne wartet auf dich.",
        gradient: "linear-gradient(45deg, rgba(255, 223, 0, 0.6), rgba(255, 140, 0, 0.7))",
      },
      {
        title: "Kälte draussen Sonne im Herzen",
        text: "Hol dir das Sommerfeeling zurück. <br>Antalya Strand und Fitness geben dir neue Motivation.",
        gradient: "linear-gradient(45deg, rgba(64, 224, 208, 0.65), rgba(0, 70, 140, 0.8))",
      },
      {
        title: "Denk jetzt an dein Sommerziel",
        text: "Sichere dir deinen Platz in der Sonne. <br>Nur wenige Plätze für die Sportwoche 2026.",
        gradient: "linear-gradient(45deg, rgba(255, 99, 71, 0.7), rgba(255, 165, 0, 0.75))",
      },
      {
        title: "Sportwoche 2026 jetzt reservieren",
        text: [
          "📅 30. Mai – 06. Juni 2026",
          "📍 Ali Bey Club Manavgat, Antalya",
          "💥 Fitness Ferien und Feeling",
          "🔥 Training Sonne und Community",
          //  "👉 Alle Infos & Buchung: app.wellcomefit.ch/alibey",
        ],
        gradient: "linear-gradient(45deg, rgba(226, 179, 59, 0.75), rgba(184, 115, 51, 0.8))",
      },
    ],
  }),

  computed: {
    currentGradient() {
      if (this.slides[this.step]) {
        return this.slides[this.step].gradient
      }
      return "linear-gradient(45deg, rgba(255, 165, 0, 0.65), rgba(30, 144, 255, 0.75))"
    },
  },

  watch: {
    step(newVal) {
      this.stopProgress()
      if (newVal < this.slides.length - 1) {
        this.startProgress()
      }
    },
  },

  mounted() {
    return
    if (window.location.host.includes("localhost")) {
      this.sheet = true
      this.startProgress()
      return
    }
    const today = new Date().toISOString().split("T")[0]
    const lastShownDate = localStorage.getItem("sportwochePromoLastShown")

    if (lastShownDate !== today) {
      setTimeout(() => {
        this.sheet = true
        this.startProgress()
      }, 1500)
    }
  },

  beforeDestroy() {
    this.stopProgress()
  },

  methods: {
    startProgress() {
      this.progress = 0
      this.progressInterval = setInterval(() => {
        if (this.progress < 100) {
          this.progress += 100 / (this.slideDuration / 100)
        } else {
          this.nextStep()
        }
      }, 100)
    },

    stopProgress() {
      clearInterval(this.progressInterval)
      this.progressInterval = null
    },

    nextStep() {
      if (this.step < this.slides.length - 1) {
        this.step += 1
      }
    },

    closeSheet() {
      this.sheet = false
      this.stopProgress()
      const today = new Date().toISOString().split("T")[0]
      localStorage.setItem("sportwochePromoLastShown", today)
    },

    bookNow() {
      window.location.href = "https://app.wellcomefit.ch/alibey"
      this.closeSheet()
    },
  },
}
</script>

<style scoped>
.v-card {
  width: 100%;
  height: auto;
  min-height: 300px;
  display: flex;
  flex-direction: column;
  transition: min-height 0.3s ease-in-out;
}

.v-card.last-slide-active {
  min-height: 350px;
}

/* NEUE KEYFRAME-ANIMATION: "Ken Burns" 
  Zoomt langsam ins Bild und zurück.
*/
@keyframes ken-burns-slow-zoom {
  from {
    transform: scale(1);
  }
  to {
    transform: scale(1.1); /* 10% Zoom */
  }
}

.promo-background {
  flex-grow: 1;
  position: relative;
  background-image: url("https://images.unsplash.com/photo-1507525428034-b723a996f6ea?auto=format&fit=crop&w=1200&q=80");
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  /* Stellt sicher, dass das Bild beim Zoomen nicht übersteht */
  overflow: hidden;
  /* Setzt die Transformation für die Animation */
  transform: scale(1);
  transition: transform 0.5s ease-out;
}

/* NEU: Aktiviert die Animation, wenn das Sheet sichtbar ist */
.promo-background.ken-burns-active {
  /* animation: ken-burns-slow-zoom 30s ease-in-out infinite alternate;*/
}

/* Keyframes für die sanfte Hintergrundanimation (Schimmern) */
@keyframes subtle-gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.promo-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  transition: background-image 0.8s ease-in-out;
  background-size: 200% 200%;
  animation: subtle-gradient-animation 15s ease infinite;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

/* Animation für den Slide-In-Text */
@keyframes slide-in-up {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.slide-in-up {
  animation: slide-in-up 0.6s ease-out forwards;
}

/* NEUE KEYFRAME-ANIMATION: "fade-in-down"
  Für den Close-Button
*/
@keyframes fade-in-down {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* NEU: Animation für den Close-Button */
.close-btn-animation {
  opacity: 0; /* Startet unsichtbar */
  animation: fade-in-down 0.5s ease-out 0.8s forwards; /* 0.8s Verzögerung */
}

/* NEUE KEYFRAME-ANIMATION: "cta-pop"
  Für den finalen Buchen-Button
*/
@keyframes cta-pop {
  0% {
    transform: scale(1);
  }
  80% {
    transform: scale(1);
  }
  90% {
    transform: scale(1.08); /* "Pop"-Effekt */
  }
  100% {
    transform: scale(1);
  }
}

/* NEU: Animation für den CTA-Button */
.cta-button-animation {
  /* Startet 1s nachdem die Slide-in-Animation (0.6s) 
    mit ihrer Verzögerung (0.2s) fertig ist.
  */
  animation: cta-pop 1.5s ease-out 0.8s;
}

.v-window-item p {
  white-space: pre-wrap;
}

.last-slide-text {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
}
</style>
